<template>
  <div>
    <section class="page-content-container">
      <div class="single-product__container">
        <div class="single-product__image">
          <img
            :src="currentProduct.custom_fields.product_image.url"
            :alt="currentProduct.custom_fields.product_image.alt"
          >
        </div>

        <div class="single-product__content">
          <h1 class="single-product__title">{{ currentProduct.custom_fields.product_name }}</h1>
          <h4 class="single-product__sku">{{ currentProduct.custom_fields.myfirstech_sku }}</h4>
          <div
            v-if="currentProduct.custom_fields"
            class="single-product__content--description">
            <h5
              class="single-product__content--price"
            >${{ (currentProduct.custom_fields.product_price * 1).toFixed(2) }}</h5>
            <p>{{ currentProduct.custom_fields.product_description }}</p>
            <ul v-if="currentProduct.custom_fields.includes">
              <li
                v-for="(includeItem, key) in currentProduct.custom_fields.includes"
                :key="key"
              >{{ includeItem.item }}</li>
            </ul>
          </div>

          <div class="single-product__content--cta">
            <button
              class="button more-info-button add-to-cart-button"
              @click="addProduct()"
            >Add to Cart</button>
            <a
              v-if="currentProduct.custom_fields.amazon_product_link"
              :href="currentProduct.custom_fields.amazon_product_link"
              rel="noopener"
              class="single-product__content--amazon-link"
            >
              Also at
              <img
                src="/img/amazon_logo_black.png"
                alt="Aquabed on Amazon"
                width="75"
              >
            </a>
          </div>
        </div>
      </div>
    </section>

    <section id="product_features_section">
      <!-- Pass dynamic content to banner -->
      <!-- Pass dynamic content to faqs -->
      <faqs
        v-if="currentProduct.custom_fields.faqs"
        :faqs="currentProduct.custom_fields.faqs"/>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import InfoBanner from '~/components/product-page/InfoBanner'
import Faqs from '~/components/product-page/Faqs'

export default {
  components: {
    InfoBanner,
    Faqs
  },
  head () {
    return {
      title: this.currentProduct.custom_fields ? this.currentProduct.custom_fields.page_title : '',
      meta: [
        { hid: 'description', name: 'description', content: this.currentProduct.custom_fields ? this.currentProduct.custom_fields.meta_descriptio : '' }
      ]
    }
  },
  computed: {
    ...mapGetters('products', {
      products: 'products'
    }),
    currentProduct () {
      const productSlug = this.$route.params.slug
      let productFromState = this.$store.getters['products/currentSystem'](productSlug)

      return productFromState
    },
    cleanProduct () {
      const productSlug = this.$route.params.slug
      let productFromState = this.$store.getters['products/currentSystem'](productSlug)
      let newProduct = {
        description: productFromState.custom_fields.product_description,
        image: productFromState.custom_fields.product_image,
        includes: productFromState.custom_fields.includes,
        parentID: productFromState.ID,
        part_number: productFromState.custom_fields.myfirstech_sku,
        price: productFromState.custom_fields.myfirstech_price,
        stock_quantity: productFromState.custom_fields.myfirstech_inventory
      }
      return newProduct
    }
  },
  methods: {
    addProduct (variationIndex) {
      // Animate add to cart button
      const addToCartButton = document.querySelector('.add-to-cart-button')
      addToCartButton.classList.add('added-to-cart')
      addToCartButton.innerHTML = 'Added'

      setTimeout(function () {
        addToCartButton.classList.remove('added-to-cart')
        addToCartButton.innerHTML = 'Add to Cart'
      }, 2000)

      this.$store.commit('cart/ADD_TO_CART', this.cleanProduct)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content-container {
  padding: 45px 7% 45px;

  @media screen and (max-width: 1100px) {
    padding: 30px 4.5% 30px;
  }

  @media screen and (max-width: 800px) {
    padding: 30px 7% 30px;
  }
}

.single-product {
  @include e("container") {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;

    @media screen and (max-width: 800px) {
      flex-direction: column;
    }
  }

  @include e("image") {
    width: 55%;
    margin: 0 auto 0 0;
    padding-right: 60px;

    @media screen and (max-width: 1100px) {
      width: 60%;
      padding-right: 15px;
    }

    @media screen and (max-width: 800px) {
      width: 100%;
      margin: 0 auto;
      padding-right: 0px;

      img {
        width: 400px;
        display: block;
        margin: 0 auto;
      }
    }
  }

  @include e("content") {
    width: 45%;

    h1 {
      font-size: 35px;
      margin: 0;
    }

    h4 {
      margin: 6px 0 20px;
      padding-bottom: 20px;
      font-size: 14px;
      border-bottom: 1px solid #ccc;
    }

    @media screen and (max-width: 1100px) {
      width: 40%;
    }

    @media screen and (max-width: 800px) {
      width: 100%;

      h1 {
        font-size: 24px;
      }

      h4 {
        font-size: 14px;
      }
    }

    @include m("description") {
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid #ccc;

      p {
        margin: 10px 0 0px;
      }

      ul {
        margin: 0 0 20px;
        padding-left: 20px;

        li {
          margin-bottom: 5px;
          font-size: 14px;

          &:last-child {
            margin-bottom: 0px;
          }
        }
      }
    }

    @include m("price") {
      font-size: 34px;
      font-weight: bold;
      margin: 0 0 15px;
      line-height: 1em;
    }

    @include m("price-disclaimer") {
      font-size: 12px;
      margin-bottom: 10px;
      color: #919191;
    }

    @include m("select-label") {
      font-weight: bold;
      font-size: 12px;
      margin: 0px 0px 5px;
    }

    @include m("selection-container") {
      margin-bottom: 30px;

      .select-button-style {
        width: 100%;
        max-width: 400px;
      }
    }

    @include m("cta") {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      margin-bottom: 27px;

      .button {
        width: 50%;
      }

      @media screen and (max-width: 800px) {
        flex-direction: column;

        .button {
          width: 100%;
        }
      }
    }

    @include m("amazon-link") {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      margin-top: 15px;
      margin-left: 25px;
      font-size: 16px;
      line-height: 1em;
      cursor: pointer;

      img {
        margin: 3px 0 0 10px;
      }
    }

    @include m("shipping-callout") {
      width: calc(50% - 15px);
      margin-left: 30px;
      display: flex;
      flex-direction: row;

      @media screen and (max-width: 800px) {
        width: 100%;
        margin-top: 15px;
        margin-left: 0px;
        float: right;
      }

      p {
        font-size: 14px;
        margin: 0;
        line-height: 1.2em;
      }
    }
  }
}

.single_product__shipping-icon {
  background-image: url("/img/shippingicon.svg");
  width: 25px;
  height: 25px;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  margin-right: 10px;
}

.add-to-cart-button {
  min-width: 166px;
  transition: all 0.35s ease-out;
}
.added-to-cart {
  background-color: #06b559;
  transition: all 0.25s ease-in;
  position: relative;
  padding-left: 35px;

  &:before {
    content: "";
    width: 25px;
    height: 25px;
    display: block;
    position: absolute;
    left: 10px;
    top: 12px;
    background-image: url("/img/checkmark.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
</style>
